<script lang="ts">
	// Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	// Services and configs
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import { real_id, is_gen_2 } from 'src/helpers/interface_helpers';

	// Design System Components
	// Types
	import type { Device } from 'src/types/Device.ts';
	import InputsReaderVisualizerV2 from 'src/components/Controls/Indicators/InputsReaderVisualizerV2.svelte';
	import DeviceViewStateWrapper from '../DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	import {
		canShowGen1LabelList,
		createGen1CombinedLabelList,
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';

	export let device: Device;

	let btnType: string;
	$: {
		if (typeof status?.inputs !== 'undefined') {
			btnType = settings?.inputs?.[device?.channel]?.btn_type;
		} else if (is_gen_2(device)) {
			btnType = settings?.['input:' + device?.channel]?.type;
		} else {
			btnType = undefined;
		}
	}
	$: isButton = btnType === 'toggle' || btnType === 'switch';

	$: deviceConfig = devices_config?.[device?.type];
	$: isGen2 = is_gen_2(device);

	let timerLabels: Record<string, any> = {};

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses, device);

	$: combinedLabelList = createGen1CombinedLabelList(timerLabels, labelList);
</script>

<DeviceViewStateWrapper {device} hideSlotStaticBottom={isButton}>
	<div class="label-list-wrapper mb-s" slot="staticTop">
		{#if canShowGen1LabelList(device, status)}
			<DeviceLabelList labelList={combinedLabelList} />
		{/if}
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		{#if isButton}
			<InputsReaderVisualizerV2 {device} {status} {settings} isInCard={false} />
		{/if}
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if !isButton}
			<InputsReaderVisualizerV2 {device} {status} {settings} isInCard={false} />
		{/if}
	</div>
</DeviceViewStateWrapper>
